module.exports = __webpack_public_path__ + "img/share-22.633ce74f.jpg";